import { render, staticRenderFns } from "./EditorNotFound.vue?vue&type=template&id=31fea8da&scoped=true"
import script from "./EditorNotFound.vue?vue&type=script&lang=js"
export * from "./EditorNotFound.vue?vue&type=script&lang=js"
import style0 from "./EditorNotFound.vue?vue&type=style&index=0&id=31fea8da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31fea8da",
  null
  
)

export default component.exports